import React from 'react'

const Ofp = ({ofp}) => {
    if(ofp){
        ofp = JSON.parse(ofp);
    }
    return (
        <div className="flex flex-1 text-white py-6 items-center justify-center">
            <div className="p-4 h-full border border-bordercolor relative overflow-y-auto" dangerouslySetInnerHTML={{__html: ofp.text.plan_html}}>
            </div>
        </div>
    )
}

export default Ofp
